import { Box, Typography, Grid } from '@mui/material';
import { DateInput } from 'react-admin';
import styles from './filter.module.css';
import { getTodaysDate, getYesterdaysDate } from '../utils/DateUtils';
import { SetDatePropsType } from '../utils/DataTypes';

const DateRangeSelector = ({ setStartDateFunction, setEndDateFunction, setToggleFunction }: SetDatePropsType) => {
  const handleEndDateChange = (e) => {
    setEndDateFunction(e.target.value);
    setToggleFunction(true);
  };

  const handleStartDateChange = (e) => {
    setStartDateFunction(e.target.value);
    setToggleFunction(true);
  };

  return (
    <div>
      <Typography className={styles.header_3} variant="h7" gutterBottom>
        Date Range
      </Typography>

      <Grid item xs={6} display="flex" gap={1}>
        <Box flexGrow={1} display="flex" flex-direction="row" component="span" mr={2}>
          <DateInput
            //{...methods.register("start_date")}

            className={styles.date_input}
            name="start_date"
            defaultValue={getYesterdaysDate}
            value={getYesterdaysDate}
            onChange={handleStartDateChange}
            source="start_date"
            label="Start Date"
            inputProps={{
              min: '2022-04-22T00:00',
              max: '2022-04-28T00:00',
            }}
            //border: 2px solid green;
          />
          <h3>-</h3>
          <DateInput
            name="end_date"
            defaultValue={getTodaysDate}
            source="end_date"
            label="End Date"
            onChange={handleEndDateChange}
          />
        </Box>
      </Grid>
    </div>
  );
};

export default DateRangeSelector;
